import styled from 'styled-components/macro'
import palette from 'src/designSystem/variables/palette'
import { FilterDropdownToggle } from 'src/components/Reusable/IndexPage/FilterBar/FilterBar.styles'

export const PrimaryButton = styled(FilterDropdownToggle)`
  border: none;
  border-radius: 8px;
  background-color: ${palette.neutral[900]};
  height: 32px;
  padding-left: 12px;
  padding-right: 12px;
  font-size: 12px;
  font-weight: 600;
  display: flex;
  align-items: center;
  justify-content: center;
  white-space: nowrap;
  color: ${palette.neutral.white};
  .filter-dropdown-icon {
    path:first-child {
      fill: none !important;
    }
    path:last-child {
      stroke: ${palette.neutral.white} !important;
      fill: ${palette.neutral.white} !important;
    }
  }
  cursor: pointer;
  &:hover,
  &:focus,
  &:active,
  &.show {
    box-shadow: none !important;
    background-color: ${palette.neutral[900]};
  }
`

// The same toggle in the app's secondary treatment -- white, bordered, dark
// label -- matching theme.ts's `cancel` button variant, for headers where the
// dark button belongs to the primary action next to it.
export const SecondaryButton = styled(PrimaryButton)`
  background-color: ${palette.neutral.white};
  border: 1px solid ${palette.neutral[900]};
  color: ${palette.neutral[900]};
  .filter-dropdown-icon {
    path:last-child {
      stroke: ${palette.neutral[900]} !important;
      fill: ${palette.neutral[900]} !important;
    }
  }
  &:hover,
  &:focus,
  &:active,
  &.show {
    background-color: ${palette.neutral[50]};
  }
`

export const DropdownPrimaryButtonMenu = styled.div`
  border-radius: 16px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  padding: 8px;
  overflow: visible;
`

export const DropdownPrimaryButtonMenuItem = styled.div`
  width: 100%;
  height: 100%;
  margin: 0;
  padding: 3px 12px !important;
  line-height: 18px;
  border-radius: 8px;
  cursor: pointer;
  overflow: hidden;
  color: ${palette.neutral.black};
  font-feature-settings: 'liga' off, 'clig' off;
  text-overflow: ellipsis;
  font-family: Poppins, sans-serif;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  letter-spacing: 0.15px;
  white-space: nowrap;
  &:hover,
  &:focus,
  &:active,
  &.show {
    background-color: ${palette.neutral[100]};
  }

  &.custom-disabled {
    color: ${palette.neutral[400]};
    cursor: default;

    &:hover {
      background-color: transparent;
    }
  }
`

export const DropdownPrimaryButtonDivider = styled.hr`
  margin: 2px -8px;
  border: none;
  border-top: 1px solid ${palette.neutral[100]};
`
